import { type ChangeEventHandler, type FC } from 'react';
import { useUnit } from 'effector-react';
import { Group, MultiSelect, TextInput } from '@mantine/core';
import {
    type PayoutTraderStatus,
    payoutTraderStatuses,
    type PayoutTraderWorkingStatus,
    payoutTraderWorkingStatuses,
    payoutWorkStrategies,
    type PayoutWorkStrategy,
} from '~/entities/payout';
import { useDebouncedField } from '~/shared/lib/hooks/useDebouncedField';
import { $tradersFilter, setTradersFilter } from '../model';
import { debounceTimeout } from '../constants';

export const TradersFilter: FC = () => {
    const values = useUnit($tradersFilter);

    const traderName = useDebouncedField({
        initialValue: values.traderName?.value ?? '',
        delay: debounceTimeout,
        onChange: (value: string) => setTradersFilter({ traderName: { value } }),
    });

    const bankAccountId = useDebouncedField({
        initialValue: values.bankAccountId ?? '',
        delay: debounceTimeout,
        onChange: (value: string) => setTradersFilter({ bankAccountId: value }),
    });

    const handleChangeTraderName: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        traderName.onChange(value);
    };

    const handleChangeBankAccountId: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        bankAccountId.onChange(value);
    };

    return (
        <div>
            <Group
                wrap='wrap'
                gap='md'
            >
                <MultiSelect
                    size='xs'
                    flex={1}
                    miw={240}
                    searchable
                    label='Статусы'
                    value={values.statuses}
                    data={payoutTraderStatuses}
                    onChange={(value) => setTradersFilter({ statuses: value as PayoutTraderStatus[] })}
                    clearable
                />

                <TextInput
                    flex={1}
                    size='xs'
                    miw={240}
                    label='Имя трейдера'
                    value={traderName.value}
                    onChange={handleChangeTraderName}
                />

                <TextInput
                    flex={1}
                    size='xs'
                    miw={240}
                    label='ID счета'
                    value={bankAccountId.value}
                    onChange={handleChangeBankAccountId}
                />
            </Group>

            <Group
                wrap='wrap'
                gap='md'
            >
                <MultiSelect
                    flex={1}
                    size='xs'
                    miw={240}
                    searchable
                    label='Статус работы'
                    value={values.workingStatuses}
                    data={payoutTraderWorkingStatuses}
                    onChange={(value) => setTradersFilter({ workingStatuses: value as PayoutTraderWorkingStatus[] })}
                    clearable
                />

                <MultiSelect
                    flex={1}
                    size='xs'
                    miw={240}
                    searchable
                    label='Стратегия работы'
                    value={values.workStrategies}
                    data={payoutWorkStrategies}
                    onChange={(value) => setTradersFilter({ workStrategies: value as PayoutWorkStrategy[] })}
                    clearable
                />
            </Group>
        </div>
    );
};
